export function getPlural(
  count: number,
  singular: string,
  plural: string = `${singular}s`
) {
  const rules = new Intl.PluralRules("en-US");
  const pluralCategory = rules.select(count);

  return pluralCategory === "one" ? singular : plural;
}
